import { useState, useRef } from 'react';
import FormBuilderModalView from './view';

export default function FormBuilderModal({ modalRef, communityId: communityIdProp }) {
    const [open, setOpen] = useState(false);
    const [communityIdOverride, setCommunityIdOverride] = useState(null);
    const [editFormId, setEditFormId] = useState(null);
    const [templateData, setTemplateData] = useState(null);
    const [sessionKey, setSessionKey] = useState(0);
    const onSuccessRef = useRef(null);

    const communityId = communityIdOverride ?? communityIdProp ?? null;

    modalRef.current = {
        open(community, onSuccess) {
            const id = community?.id ?? (typeof community === 'number' || typeof community === 'string' ? community : null);
            if (id != null) setCommunityIdOverride(id);
            onSuccessRef.current = onSuccess ?? null;
            setEditFormId(null);
            setTemplateData(null);
            setSessionKey(k => k + 1);
            setOpen(true);
        },
        edit(community, formId, onSuccess) {
            const id = community?.id ?? (typeof community === 'number' || typeof community === 'string' ? community : null);
            if (id != null) setCommunityIdOverride(id);
            onSuccessRef.current = onSuccess ?? null;
            setEditFormId(formId ?? null);
            setTemplateData(null);
            setSessionKey(k => k + 1);
            setOpen(true);
        },
        openWithTemplate(community, tmplData, onSuccess) {
            const id = community?.id ?? (typeof community === 'number' || typeof community === 'string' ? community : null);
            if (id != null) setCommunityIdOverride(id);
            onSuccessRef.current = onSuccess ?? null;
            setEditFormId(null);
            setTemplateData(tmplData ?? null);
            setSessionKey(k => k + 1);
            setOpen(true);
        },
        close() {
            setOpen(false);
        },
    };

    function handleClose() {
        setOpen(false);
        setCommunityIdOverride(null);
        setTemplateData(null);
    }

    function handleSaveSuccess() {
        setOpen(false);
        setCommunityIdOverride(null);
        setTemplateData(null);
        onSuccessRef.current?.();
    }

    return (
        <FormBuilderModalView
            key={sessionKey}
            open={open}
            onClose={handleClose}
            onSaveSuccess={handleSaveSuccess}
            communityId={communityId}
            editFormId={editFormId}
            templateData={templateData}
        />
    );
}
